var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "integralUser seller-style" }, [
    _c(
      "div",
      [
        _c(
          "router-link",
          { attrs: { to: "/mj/integral/user" } },
          [_c("el-button", { attrs: { type: "primary" } }, [_vm._v("返回")])],
          1
        ),
        _c("div", { staticClass: "box30" }),
        _c(
          "el-table",
          {
            attrs: {
              border: "",
              data: _vm.pointsRecord,
              "row-class-name": "pointer"
            }
          },
          [
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "usedPoints",
                "min-width": "15%",
                label: "获得/消耗数量"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.type === 1 || scope.row.type === 4
                              ? "+"
                              : "-"
                          ) +
                          _vm._s(scope.row.usedPoints) +
                          " "
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "ptTypeName",
                label: "来源/用途",
                "min-width": "15%"
              }
            }),
            _c("el-table-column", {
              attrs: { prop: "createDate", label: "时间", "min-width": "15%" }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "pad30-t t_right" },
      [
        _c("el-pagination", {
          attrs: {
            "popper-class": "seller-style",
            "current-page": _vm.currentPage,
            "page-sizes": [10, 20, 50],
            "page-size": _vm.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.totalCount
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }